<template>
<nav>
  <v-app-bar app dark clipped-left color="#37BC9B">
    <v-app-bar-nav-icon @click="drawer = !drawer" />
    <a href="/app/">
      <v-img
        :src="require('@assets/logo/Logo_SemFundo_semNome_Agrosim_branco.png')" alt="AgroSim"
        max-width="50"
        class="ml-3"
        contain
      />
    </a>
    <a href="/app/">
      
      <v-img
        :src="require('@assets/logo/Nome_SemLogo_SemFundo_Agrosim_branco.png')" alt="AgroSim"
        max-width="120"
        class="mx-3"
        contain
      />

    </a>

    <v-toolbar-title class="caption d-none d-lg-flex">V4.9.911</v-toolbar-title>

    <v-autocomplete
      v-model="searchedMenu"
      :items="itemsMenuForSearch"
      clearable
      label="Filtrar Páginas do Menu"
      prepend-icon="mdi-magnify"
      class="ml-4 mt-6 d-none d-md-flex"
      item-text="title"
      @click="menuSearch"
      :menu-props="{closeOnContentClick: true}"
      v-shortkey.focus="{windows: ['ctrl', 'k'], mac: ['meta', 'k']}"
    >
      <template v-slot:item="{ item }">
        <v-list-item link :to="item.link_to">{{item.title}}</v-list-item>
      </template>
    </v-autocomplete>

    <v-spacer></v-spacer>

    <v-toolbar-items class="d-none d-lg-flex">
      <SelectGround
        ref="selectGround"
        newTitle="Selecionar Área"
        :openSelectButtonLabel="loggedUser.ground ? loggedUser.ground.name : ''"
        :idSelectedItem="loggedUser.groundId"
        :idParentSelectedItem="loggedUser.accountId"
        @select-action="groundSelected"
      />

      <!-- <v-btn text :href="'/admin/user/' + loggedUser.id + '/edit'"> -->
      <v-btn text id="user_button">
        <v-icon left class="" style="margin-right: -10px;">mdi-account</v-icon>
        <!-- {{loggedUser ? (loggedUser.person ? loggedUser.person.name : '') : ''}} -->
        <UserEdit
          :entry="loggedUser"
          :isTextButton="true"
          :textButton="loggedUser ? (loggedUser.person ? loggedUser.person.name : '') : ''"
          :editButtonTooltipTop="false"
          :allowPasswordEditing="true"
          :isEdit="true"
          id="userEditPrintableELement"
        />
      </v-btn>

      <v-btn text color="error" @click="userSignOut">
        Sair
        <v-icon right dark>mdi-logout</v-icon>
      </v-btn>
    </v-toolbar-items>

    <v-menu 
      offset-y
      class="d-lg-none"
      v-model="showMenu"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          icon
          v-bind="attrs"
          v-on="on"
          class="d-lg-none"
        >
          <v-icon>mdi-dots-vertical</v-icon>
        </v-btn>
      </template>
      <v-list>
        <v-list-item>
          <SelectGround
            ref="selectGround"
            newTitle="Selecionar Área"
            :openSelectButtonLabel="loggedUser.ground ? loggedUser.ground.name : ''"
            :idSelectedItem="loggedUser.groundId"
            :idParentSelectedItem="loggedUser.accountId"
            @select-action="groundSelected"
            @new-cancel-action="showMenu = false"
          />
        </v-list-item>

        <v-list-item>
          <v-btn text>
            <v-icon left class="" style="margin-right: -10px;">mdi-account</v-icon>
            <!-- {{loggedUser ? (loggedUser.person ? loggedUser.person.name : '') : ''}} -->
            <UserEdit
              :entry="loggedUser"
              :isTextButton="true"
              :textButton="loggedUser ? (loggedUser.person ? loggedUser.person.name : '') : ''"
              :editButtonTooltipTop="false"
              buttonColor="rgb(36 36 36)"
              @entry-canceled="showMenu = false"
              @entry-updated="showMenu = false"
            />
          </v-btn>
        </v-list-item>

        <v-list-item>
          <v-btn text color="error" @click="userSignOut">
            Sair
            <v-icon right dark>mdi-logout</v-icon>
          </v-btn>
        </v-list-item>
      </v-list>
    </v-menu>
  </v-app-bar>

  <v-navigation-drawer clipped app v-model="drawer" dark color="#273135">
    <v-list dense>

      <v-list-item link to="/app/" v-if="$can('read', 'Home')">
        <v-list-item-action>
          <v-icon>mdi-home</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>Home</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-list-item link to="/app/dashboard" v-if="$can('read', 'Dashboard')">
        <v-list-item-action>
          <v-icon>mdi-poll-box</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>Dashboard</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-list-item link to="/app/dashboard_altavenda" v-if="$can('read', 'DashboardAltavenda')">
        <v-list-item-action>
          <v-icon>mdi-calendar-clock-outline</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>Compromissos</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-list-item link to="/app/dashboard_goals" v-if="$can('read', 'DashboardGoal')">
        <v-list-item-action>
          <v-icon>mdi-calendar-clock-outline</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>Metas</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <!-- MENU -->
      <template v-for="item in menu">
        <v-list-group
          :value="item.active"
          :key="item.title"
          :prepend-icon="item.icon"
          no-action
          @input="onItemClick($event, item)"
          color="white"
          v-if="!_.isEmpty(_.pickBy(item.items, function(value, key) {return $can('read', value.model ? value.model : '')})) && ((item.only_for_admin == true && $can('create', 'UserForAdmin')) || (item.only_for_admin != true ))"
        >
          <!-- :class="{'menu-back-selected': item.active}" -->
          <!-- active-class="menu-back-selected"
          :class="item.active ? 'menu-back-selected' : 'menu-back-item'" -->
          <template slot="activator">
            <v-list-item-content >
              <v-list-item-title>{{ item.title }}</v-list-item-title>
            </v-list-item-content>
          </template>

          <template v-for="subItem in item.items">
            <v-tooltip right :key="subItem.title + 'tooltip'" color="#1a1a1a" :open-delay="300">
              <template v-slot:activator="{ on }">
                <v-list-item
                  :href="subItem.link ? subItem.link : ''"
                  :to="subItem.link_to ? subItem.link_to : ''"
                  :class="'custom-padding ' + (subItem.class ? subItem.class : '')"
                  :key="subItem.title"
                  v-if="$can('read', subItem.model ? subItem.model : '')"
                  v-on="on"
                >
                <!-- v-if="$can('read', subItem.model ? subItem.model : '')" -->
                  <v-list-item-icon>
                    <v-icon v-text="subItem.icon"></v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>{{ subItem.title }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </template>
              <span>{{ subItem.title }}</span>
            </v-tooltip>
          </template>
          <!-- <template
            v-if="item.can = !_.isEmpty(_.pickBy(item.items, function(value, key) {return value.can}))"
          /> -->
        </v-list-group>
      </template>
      <!-- FIM DO MENU -->

    </v-list>
  </v-navigation-drawer>
  </nav>
</template>

<script>
import SelectGround from "@models/grounds/select.vue";
import UserEdit from "@models/users/edit.vue";

export default {
  data() {
    return {
      drawer: null,
      loggedUser: {},
      svgLogo: null,
      selected: "",
      searchedMenu: null,
      showMenu: false,
      menu: [
        {
          title: "Cadastros",
          items: [
            {
              icon: "mdi-account",
              title: "Memória",
              link_to: "/app/memories",
              model: "Memory",
            },
            {
              icon: "mdi-account",
              title: "Contas",
              link_to: "/app/accounts",
              model: "Account",
            },
            {
              icon: "mdi-map",
              title: "Fazendas/Propriedades",
              link_to: "/app/grounds",
              model: "Ground",
            },
            {
              icon: "mdi-map-marker",
              title: "Talhões",
              link_to: "/app/fields",
              model: "Field",
            },
            {
              icon: "mdi-ungroup",
              title: "Grupos de Itens",
              link_to: "/app/groups",
              model: "Group",
            },
            {
              icon: "mdi-flag-variant",
              title: "Marcas",
              link_to: "/app/brands",
              model: "Brand",
            },
            {
              icon: "mdi-bolt",
              title: "Peças",
              link_to: "/app/parts",
              model: "Part",
            },
            {
              icon: "mdi-water",
              title: "Óleos/Combustíveis",
              link_to: "/app/oils",
              model: "Oil",
            },
            {
              icon: "mdi-tools",
              title: "Ferramentas",
              link_to: "/app/tools",
              model: "Tool",
            },
            {
              icon: "mdi-asterisk",
              title: "Itens Diversos",
              link_to: "/app/others",
              model: "Other",
            },
            {
              icon: "mdi-briefcase",
              title: "Embalagens",
              link_to: "/app/packagings",
              model: "Packaging",
            },
            {
              icon: "mdi-tractor",
              title: "Patrimônios",
              link_to: "/app/patrimonies",
              model: "Patrimony",
            },
            // {
            //   icon: "mdi-account-group",
            //   title: "Funcionários",
            //   link: this.getURL("/admin/employee"),
            //   model: "Employee",
            // },
            // {
            //   icon: "mdi-account-group",
            //   title: "Fornecedores",
            //   link: this.getURL("/admin/supplier"),
            //   model: "Supplier",
            // },
            {
              icon: "mdi-map-marker-path",
              title: "Rotas",
              link_to: "/app/routes",
              model: "Route",
            },
            {
              icon: "mdi-calendar-clock-outline",
              title: "Compromissos",
              link_to: "/app/agendas",
              model: "Agenda",
            },
            {
              icon: "mdi-map",
              title: "Regiões",
              link_to: "/app/regions",
              model: "Region",
            },
            {
              icon: "mdi-account-group",
              title: "Pessoas",
              link_to: "/app/people",
              model: "Person",
            },
            {
              icon: "mdi-account-group",
              title: "Pessoas Altavenda",
              link_to: "/app/people_altavenda",
              model: "PersonAlta",
            },
            {
              icon: "mdi-label",
              title: "Etiquetas",
              link_to: "/app/labels",
              model: "Label",
            },
            {
              icon: "mdi-account",
              title: "Usuários",
              // link: this.getURL("/admin/user"),
              link_to: "/app/users",
              model: "User",
            },
          ]
        },
        {
          title: "Armazenagem",
          items:[
            {
              icon: "mdi-warehouse",
              title: "Saldo das Variedades",
              link_to: "/app/variety_balances",
              model: "VarietyBalance",
            },
            {
              icon: "mdi-warehouse",
              title: "Estoques",
              link_to: "/app/storages",
              model: "Storage",
            },           
            {
              icon: "mdi-warehouse",
              title: "Estufas",
              link_to: "/app/greenhouses",
              model: "Greenhouse",
            },
            {
              icon: "mdi-warehouse",
              title: "WMS",
              link_to: "/app/storage_shelves",
              model: "StorageShelf",
            },
            {
              icon: "mdi-ballot-recount",
              title: "Transferência de Estoques",
              link_to: "/app/storage_transfers",
              model: "StorageTransfer",
            },
            {
              icon: "mdi-tooltip-edit",
              title: "Motivos de Ajustes de Estoque",
              link_to: "/app/stock_adjustment_reasons",
              model: "StockAdjustmentReason",
            },            
            {
              icon: "mdi-table-edit",
              title: "Ajustes de Estoque",
              link_to: "/app/storage_adjustments",
              model: "StorageAdjustment",
            },
            {
              icon: "mdi-atom-variant",
              title: "Transformação de Items",
              link_to: "/app/item_transformations",
              model: "ItemTransformation",
            },
            {
              icon: "mdi-database-clock",
              title: "Movimentações",
              link_to: "/app/storage_movements_report",
              model: "StorageMovementsReport",
            },
            // {
            //   icon: "mdi-format-list-checks",
            //   title: "Inventário de Estoque",
            //   link_to: "/app/stock_inventory_report",
            //   model: "StockInventoryReport",
            // },
            {
              icon: "mdi-format-list-checks",
              title: "Inventário de Estoque",
              link_to: "/app/storage_inventory_report",
              model: "StorageInventoryReport",
            },
            {
              icon: "mdi-format-list-checks",
              title: "Inventário WMS",
              link_to: "/app/inventory_wms_report",
              model: "InventoryWMSReport",
            },
            // {
            //   icon: "mdi-format-list-checks",
            //   title: "Inventário de Depósito",
            //   link_to: "/app/storehouse_inventory_report",
            //   model: "StorehouseInventoryReport",
            // },
          ]
        },
        {
          title: "Financeiro",
          items: [
            {
              icon: "mdi-piggy-bank",
              title: "Contas Bancárias",
              link_to: "/app/bank_accounts",
              model: "BankAccount",              
            },
            {
              icon: "mdi-bank-transfer",
              title: "Operações Bancárias",
              link_to: "/app/bank_account_operations",
              model: "BankAccountOperation",
            },
            {
              icon: "mdi-currency-usd",
              title: "Contas a Pagar",
              link_to: "/app/cash_outflows",
              model: "CashOutflow",
            },
            {
              icon: "mdi-calendar-blank",
              title: "Parcelas a Pagar",
              // link: this.getURL('/admin/cash_outflow_installment'),
              link_to: "/app/cash_outflow_installments",
              class: "menu-back-subitem",
              model: "CashOutflowInstallment",
            },
            {
              icon: "mdi-currency-usd",
              title: "Contas a Receber",
              link_to: "/app/cash_inflows",
              model: "CashInflow",
            },
            {
              icon: "mdi-calendar-blank",
              title: "Parcelas a Receber",
              // link: this.getURL('/admin/cash_inflow_installment'),
              link_to: "/app/cash_inflow_installments",
              class: "menu-back-subitem",
              model: "CashInflowInstallment",
            },
            {
              icon: "mdi-file-table-box",
              title: "Tabela de precos",
              link_to: "/app/table_prices",
              model: "TablePrice",
            },
            {
              icon: "mdi-file-sign",
              title: "Condições comerciais desconto/acréscimo",
              link_to: "/app/table_price_items",
              model: "TablePriceItem",
            },
            {
              icon: "mdi-credit-card",
              title: "Condicoes de pagamento",
              link_to: "/app/payment_condition_rules",
              model: "PaymentConditionRule",
            },
            {
              icon: "mdi-chart-bar",
              title: "Fluxo de Caixa",
              link_to: "/app/cash_book",
              model: "CashBook",
            },
            {
              icon: "mdi-chart-bar-stacked",
              title: "Fluxo de Caixa Projetado",
              link_to: "/app/projected_cash_book",
              model: "ProjectedCashBook",
            },
          ]
        },
        {
          title: "Compras",
          items: [
            {
              icon: "mdi-cart",
              title: "Pedidos de Compra",
              link_to: "/app/purchases",
              model: "Purchase",
            }
          ]
        },
        {
          title: "Vendas",
          items:[
            {
              icon: "mdi-handshake-outline",
              title: "Pedidos de Venda",
              link_to: "/app/sale_orders",
              model: "SaleOrder",
            },
            {
              icon: "mdi-handshake",
              title: "Vendas",
              link_to: "/app/sales",
              model: "Sale",
            },
            {
              icon: "mdi-cash-register",
              title: "Tabela preco produto",
              link_to: "/app/table_price_products",
              model: "TablePriceProduct",
            },
            {
              icon: "mdi-finance",
              title: "Metas",
              link_to: "/app/goals",
              model: "Goal",
            },
          ]
        },
        {
          title: "Serviços",
          items:[
            {
              icon: "mdi-tools",
              title: "Serviços de Patrimônios",
              link_to: "/app/services_provision",
              model: "ServiceProvision",
            },
          ]
        },
        {
          title: "Produção",
          items:[
            {
              icon: "mdi-sprout",
              title: "Safras",
              link_to: "/app/harvests",
              model: "Harvest",
            },
            {
              icon: "mdi-cached",
              title: "Ciclos",
              link_to: "/app/periods",
              model: "Period",
            },
            {
              icon: "mdi-tractor",
              title: "Operações",
              link_to: "/app/execution_operations",
              model: "ExecutionOperation",
            },
            {
              icon: "mdi-tractor",
              title: "Operações de viveiro",
              link_to: "/app/seed_plot_operations",
              model: "SeedPlotOperation",
            },
            {
              icon: "mdi-qrcode",
              title: "Lotes de destinação",
              link_to: "/app/available_crop_lots",
              model: "AvailableCropLot",
            },
            {
              icon: "mdi-qrcode",
              title: "Lotes de venda",
              link_to: "/app/sale_lots",
              model: "SaleLotViewIndexFilter",
            },
            {
              icon: "mdi-seed-off-outline",
              title: "Perdas em estufa",
              link_to: "/app/losses",
              model: "Loss",
            },
            {
              icon: "mdi-comment-alert",
              title: "Motivos de Perdas em Ciclos",
              link_to: "/app/period_loss_reasons",
              model: "PeriodLossReason",
            },
            {
              icon: "mdi-leaf-off",
              title: "Perdas em Ciclos",
              link_to: "/app/period_losses",
              model: "PeriodLoss",
            },
            {
              icon: "mdi-chart-areaspline",
              title: "Relatório de Safra",
              link_to: "/app/harvest_execution_report",
              model: "HarvestExecutionReport",
            },
            {
              icon: "mdi-chart-histogram",
              title: "Operações em lotes",
              link_to: "/app/lot_operations_index",
              model: "LotOperationView",
            },
          ]
        },
        {
          title: "Planejamentos",
          items:[
            {
              icon: "mdi-chart-pie",
              title: "Operações",
              link_to: "/app/planning_operations",
              model: "PlanningOperation",
            }, 
            {
              icon: "mdi-chart-pie",
              title: "Operações (viveiro)",
              link_to: "/app/planning_seed_plot_operations",
              model: "PlanningSeedPlotOperation",
            },            
            {
              icon: "mdi-chart-areaspline-variant",
              title: "Relatório de Planejamento de Safra",
              link_to: "/app/harvest_planning_report",
              model: "HarvestPlanningReport",
            },
          ]
        },
        {
          title: "Catálogo",
          items:[
            {
              icon: "mdi-weight-kilogram",
              title: "Peso dos itens",
              link_to: "/app/item_weights",
              model: "ItemWeight",
            },
            {
              icon: "mdi-barley",
              title: "Culturas",
              link_to: "/app/cultures",
              model: "Culture",
            },
            {
              icon: "mdi-barley",
              title: "Subculturas",
              link_to: "/app/sub_cultures",
              model: "SubCulture",
            },
            {
              icon: "mdi-seed-outline",
              title: "Variedades",
              link_to: "/app/varieties",
              model: "Variety",
            },
            {
              icon: "mdi-seed",
              title: "Sementes",
              link_to: "/app/seeds",
              model: "Seed",
            },
            {
              icon: "mdi-sprout-outline",
              title: "Mudas",
              link_to: "/app/seedlings",
              model: "Seedling",
            },
            {
              icon: "mdi-corn",
              title: "Produtos Produzidos",
              link_to: "/app/end_products",
              model: "EndProduct",
            },
            {
              icon: "mdi-radioactive-circle",
              title: "Ingredientes Ativos",
              link_to: "/app/active_ingredients",
              model: "ActiveIngredient",
            },
            {
              icon: "mdi-flask",
              title: "Agrotóxicos",
              link_to: "/app/agrotoxics",
              model: "Agrotoxic",
            },
            {
              icon: "mdi-flask-round-bottom",
              title: "Fertilizantes",
              link_to: "/app/fertilizers",
              model: "Fertilizer",
            },
            {
              icon: "mdi-flask-outline",
              title: "Biológicos",
              link_to: "/app/biologicals",
              model: "Biological",
            },
            {
              icon: "mdi-format-list-bulleted-type",
              title: "Tipos de Operações",
              link_to: "/app/operation_types",
              model: "OperationType",
            },
            {
              icon: "mdi-arrow-decision",
              title: "Categorias de Patrimônio",
              link_to: "/app/patrimony_categories",
              model: "PatrimonyCategory",
            },
            {
              icon: "mdi-file-chart",
              title: "Plano de Contas",
              link_to: "/app/chart_of_accounts",
              model: "Chart"
            },
          ]
        },
        // {
        //   title: "Catálogo Admin",
        //   only_for_admin: true,
        //   items:[
        //     {
        //       icon: "mdi-barley",
        //       title: "Culturas",
        //       link: this.getURL('/admin/culture'),
        //       model: "Culture",
        //     },
        //     {
        //       icon: "mdi-barley",
        //       title: "Subculturas",
        //       link: this.getURL('/admin/sub_culture'),
        //       model: "SubCulture",
        //     },
        //     {
        //       icon: "mdi-seed-outline",
        //       title: "Variedade",
        //       link: this.getURL('/admin/variety'),
        //       model: "Variety",
        //     },
        //     {
        //       icon: "mdi-seed",
        //       title: "Sementes",
        //       link_to: "/app/seeds",
        //       model: "Seed",
        //     },
        //     {
        //       icon: "mdi-sprout-outline",
        //       title: "Mudas",
        //       link_to: "/app/seedlings",
        //       model: "Seedling",
        //     },
        //     {
        //       icon: "mdi-corn",
        //       title: "Produtos Finais",
        //       link_to: '/app/end_product',
        //       model: "EndProduct",
        //     },
        //     {
        //       icon: "mdi-flask",
        //       title: "Agrotóxicos",
        //       link: this.getURL('/admin/agrotoxic'),
        //       model: "Agrotoxic",
        //     },
        //     {
        //       icon: "mdi-flask-round-bottom",
        //       title: "Fertilizantes",
        //       link: this.getURL('/admin/fertilizer'),
        //       model: "Fertilizer",
        //     },
        //     {
        //       icon: "mdi-flask-outline",
        //       title: "Biológicos",
        //       link: this.getURL('/admin/biological'),
        //       model: "Biological",
        //     },
        //     {
        //       icon: "mdi-ungroup",
        //       title: "Grupos",
        //       link: this.getURL('/admin/group'),
        //       model: "Group",
        //     },
        //     {
        //       icon: "mdi-flag-variant",
        //       title: "Marcas",
        //       link: this.getURL('/admin/brand'),
        //       model: "Brand",
        //     },
        //     {
        //       icon: "mdi-format-list-bulleted-type",
        //       title: "Tipos de Operações",
        //       link: this.getURL('/admin/operation_type'),
        //       model: "OperationType",
        //     },
        //     {
        //       icon: "mdi-arrow-decision",
        //       title: "Categorias de Patrimônio",
        //       link: this.getURL('/admin/patrimony_category'),
        //       model: "PatrimonyCategory",
        //     },
        //     {
        //       icon: "mdi-file-chart",
        //       title: "Plano de Contas",
        //       link_to: "/app/chart_of_accounts",
        //       model: "Chart"
        //     },
        //   ]
        // },
        {
          title: "Documentos Fiscais",
          name: "FiscalDocumentsMenu",
          items:[
            {
              icon: "mdi-cog-transfer-outline",
              title: "Grupos de Tributação",
              link_to: "/app/nfe/outbound/taxation_groups",
              model: "TaxationGroup" //TaxationRule
            },
            {
              icon: "mdi-cog-transfer-outline",
              title: "CFOPs",
              link_to: "/app/nfe/outbound/cfops",
              model: "Cfop"
            },
            {
              icon: "mdi-file-certificate",
              title: "NFP-e de Saída",
              link_to: "/app/outbound_nfes",
              model: "OutboundNfe"
            },
            {
              icon: "mdi-receipt",
              title: "NFC-e de Saída",
              link_to: "/app/outbound_nfces",
              model: "OutboundNfce"
            },
            {
              icon: "mdi-truck-fast",
              title: "MDF-e de Saída",
              link_to: "/app/outbound_mdfes",
              model: "OutboundMdfe"
            },
            {
              icon: "mdi-account-wrench-outline",
              title: "NFS-e de Saída",
              link_to: "/app/outbound_nfses",
              model: "OutboundNfse"
            },
          ]
        },
        {
          title: "Relatórios",
          items:[
            {
              icon: "mdi-chart-line",
              title: "Custo de Produção",
              link_to: "/app/production_cost_report",
              model: "ProductionCostReport",
            }, 
            {
              icon: "mdi-chart-multiple",
              title: "Custo Planejado de Produção",
              link_to: "/app/production_cost_planning_report",
              model: "ProductionCostPlanningReport",
            },
            {
              icon: "mdi-finance",
              title: "Resultado de Produção",
              link_to: "/app/production_result_report",
              model: "ProductionResultReport",
            },
            {
              icon: "mdi-finance",
              title: "Resultado de Produção (Viveiro)",
              link_to: "/app/seedling_production_result_report",
              model: "SeedlingProductionResultReport",
            },
            {
              icon: "mdi-clipboard-text-clock",
              title: "Relatório de Produtividade e Área Plantada",
              link_to: "/app/productivity_report",
              model: "ProductivityReport",
            },
            {
              icon: "mdi-chart-bar",
              title: "Plano de Contas",
              link_to: "/app/chart_of_accounts_report",
              model: "ChartOfAccountsReport",
            },
            {
              icon: "mdi-chart-gantt",
              title: "Disponibilidade de Produção",
              link_to: "/app/available_production_report",
              model: "AvailableProductionReport",
            },
            {
              icon: "mdi-chart-gantt",
              title: "Disponibilidade de Produção (Viveiro)",
              link_to: "/app/seedling_available_production_report",
              model: "AvailableProductionViewReport",
            },
            {
              icon: "mdi-sprout",
              title: "Mudas por Ciclo",
              link_to: "/app/seedling_by_period_report",
              model: "SeedlingByPeriodReport",
            },
            {
              icon: "mdi-sprout-outline",
              title: "Semeios MAPA",
              link_to: "/app/seedling_planting_mapa_report",
              model: "SeedlingPlantingMapaReport",
            },
            {
              icon: "mdi-sprout-outline",
              title: "MAPA (Anexo III)",
              link_to: "/app/seedling_year_production_report",
              model: "SeedlingYearProductionReport",
            },
            {
              icon: "mdi-sprout-outline",
              title: "Relatório de custo de producao",
              link_to: "/app/seedling_production_cost_report",
              model: "SeedlingProductionCostReport",
            },
            {              
              icon: "mdi-chart-arc",
              title: "Operações Realizadas",
              link_to: "/app/execution_operations_report",
              model: "ExecutionOperationsReport",
            },
            {
              icon: "mdi-chart-donut",
              title: "Operações Planejadas",
              link_to: "/app/planning_operations_report",
              model: "PlanningOperationsReport",
            },
            {
              icon: "mdi-compare",
              title: "Op. Planejadas x Realizadas",
              link_to: "/app/planning_execution_operations_report",
              model: "PlanningExecutionOperationsReport",
            },
            {
              icon: "mdi-shopping-outline",
              title: "Vendas por Produto - Sintético",
              link_to: "/app/sales_by_product_synthetic_report",
              model: "SalesByProductSyntheticReport",
            },
            {
              icon: "mdi-shopping-outline",
              title: "Vendas por Produto - Sintético",
              link_to: "/app/sales_by_product_synthetic_altavenda_report",
              model: "SalesByProductSyntheticAltavendaReport",
            },
            {
              icon: "mdi-shopping",
              title: "Vendas por Produto - Analítico",
              link_to: "/app/sales_by_product_analytic_report",
              model: "SalesByProductAnalyticReport",
            },
            {
              icon: "mdi-briefcase-account-outline",
              title: "Vendas por Cliente - Analítico",
              link_to: "/app/sales_by_customer_analytic_report",
              model: "SalesByCustomerAnalyticReport",
            }, 
            {
              icon: "mdi-briefcase-account",
              title: "Produtos de Venda por Cliente - Analítico",
              link_to: "/app/sales_product_by_customer_analytic_report",
              model: "SalesProductByCustomerAnalyticReport",
            }, 
          ]
        }
      ],
    };
  },
  watch: {
    $route(to, from) {
      this.selectMenuByRoute(to.name);
    }
  },
  components: {
    SelectGround: SelectGround,
    UserEdit: UserEdit
  },
  created() {
    this.getCurrentUser(user => {
      this.loggedUser = user;
      console.log("loggedUser", this.loggedUser);
      this.$ability.update(window.abilities);     
      
      if (user && user.ground && user.ground.logo) {
        // Encode the raw SVG string safely for use in a Data URL
        const encoded = encodeURIComponent(this.loggedUser.ground.logo)
        .replace(/'/g, '%27')
        .replace(/"/g, '%22');
        this.svgLogo = `data:image/svg+xml;charset=utf-8,${encoded}`;
      }
      
      // console.log("---", this.$ability);
      // console.log("abi", window.abilities);
      // const brand = {accountId: 7};
      // console.log("subj", this);
      // console.log("can?", this.$can('read', 'Brand', 'accountId', {accountId: 8}));
      if (this.$router.currentRoute.name && !this.$can('read', this.$router.currentRoute.name)) {
        this.$router.replace("/app/restricted");
      }
      // console.log("REGRAS atualizadas", this.$router.currentRoute.name)
    });

    this.selectMenuByRoute(this.$route.name);
  },
  mounted() {
    if (window.location.search.indexOf("selectGround") > 0) {
      this.$refs.selectGround.openSelectModal();
    }
  },
  computed: {
    itemsMenuForSearch: function() {
      // this.menu[0].items[0].title
      // this.menu[0].items[0].link_to
      // v-if="$can('read', subItem.model ? subItem.model : '')"
      let allItems = [].concat(...this.menu.map(val => val.items))
      let filteredItems = allItems.filter(val => this.$can('read', val.model ? val.model : '') && val.link_to)
      return filteredItems;
    }
  },
  methods: {
    selectMenuByRoute: function(routeName) {

      for (var item in this.menu) {
        this.$set(this.menu[item], 'active', false);
        for (var sub_item in this.menu[item].items) {
          if (this.menu[item].items[sub_item].model == routeName) {
            this.$set(this.menu[item], 'active', true);
          }
        }
      }
    },
    menuSearch: function() {
      this.searchedMenu = null;
    },
    groundSelected: function(ground) {
      this.loggedUser.groundId = ground.id;
      this.loggedUser.ground = ground;
      this.getCurrentUser(user => {
        this.loggedUser = user;
      });
      this.showMenu = false;
    },
    onItemClick: function(event, item) {
      item.active = event;
      // console.log(event, item);
    },
    getURL(page){
      return window.location.protocol + "//" + window.location.host + page;
    },
    userSignOut: function() {
      let url = window.location.origin + '/users/sign_out';
      // console.log(url, document.querySelector('meta[name=csrf-token]').getAttribute('content'));
      this.axios.delete(url, {
        data: {},
        headers: {
          'X-CSRF-Token': document.querySelector('meta[name=csrf-token]').getAttribute('content')
        }
      })
      .then(function (response) {
        // console.log("sigout", response);
        window.location.href = window.location.origin + "/users/sign_in";
      })
      .catch(function (error) {
        // console.log("sigout ERROR", error);
        window.location.href = window.location.origin + "/users/sign_in";

      });
    },
    openMenuApp: function() {
      this.drawer = true;
    }
  }
};
</script>

<style scoped>
.custom-padding {
  padding-left: 30px !important;
  background: #1a1a1a !important;
  color: #37bc9b;
}

.v-list-group--active {
  background: #37bc9b;
}

.menu-back-item{
  background: #273135;
}

.menu-back-subitem{
  padding-left: 50px !important;
}

.v-list-group__header__append-icon .v-icon {
  background: white !important;
  border-radius: 90px;
  height: 15px !important;
  width: 15px !important;
  font-size: 15px !important;
}

.v-list-group__header__append-icon .mdi-chevron-down::before{
  color: #37bc9b;
}

::v-deep #user_button span button {
  color: white !important;
}
</style>
